import { cloneDeep, merge } from 'lodash'
import { StateCreator } from 'zustand'

import EStoreStateKeys from '~/models/store'

export type TAgentDefinition = {
  id: string
}

type TAgent = {
  [EStoreStateKeys.agent]: TAgentDefinition
}

export type TAgentState = TAgent & {
  setAgent(agent: Partial<TAgentDefinition>): void
}

export const initialAgentState: TAgentDefinition = {
  id: '',
}

const createAgentSlice: StateCreator<
  TAgentState,
  [['zustand/devtools', unknown]],
  []
> = (set) => ({
  agent: cloneDeep(initialAgentState),
  setAgent: (agent) =>
    set(
      (state) => ({ agent: cloneDeep(merge(state.agent, agent)) }),
      undefined,
      {
        type: 'setAgent',
        agent,
      },
    ),
})

export default createAgentSlice
